// components/ui/table/TableHead.jsx
export const TableHead = ({ children, className = "" }) => {
  return (
    <th
      className={`h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 ${className}`}
    >
      {children}
    </th>
  );
};
